import ability from './ability'

export const canNavigate = to => to.matched.some(route => !route.meta.resource || ability.can(route.meta.action || 'read', route.meta.resource))
// export const canNavigate = to => true

export const _ = undefined
